import React from "react";
import Input from "../../Components/Input";
import Button from '../../Components/Button'
import Messages from '../../Components/Messages'
import http from "../../Api/http";
import ProgressSpinner from '../../Components/ProgressSpinner'
import Dialog from '../../Components/Dialog';
import Util from '../../Util';
import DataGrid from '../../Components/DataGridView/DataGridView';
import ButtonsBarLookupList from "../../Components/ButtonsBarLookupList";
import Card from "../../Components/Card";
import Dropdown from "../../Components/Dropdown";
import MultiSelect from "../../Components/MultiSelect";
import Calendar from "../../Components/Calendar";
import InputTime from "../../Components/InputTime";
import { Accordion, AccordionTab } from "primereact/accordion";
import SiteMap from "../../Components/SiteMap";
import Checkbox from "../../Components/Checkbox";
import AdditionalFilters from "../AdditionalFilters/AdditionalFilters";
import Print from "../../Print";

const $ = window.$;
const stringHash = require('@sindresorhus/string-hash');

export default class RecalculateBalances extends React.Component {

    constructor(props) {
        super(props);
        this.processTypesList = [
            { id: 1, name: $.strings.recalculateBalances.annualLeaveBalance },
            { id: 2, name: $.strings.recalculateBalances.sickLeaveBalance },
            { id: 3, name: $.strings.recalculateBalances.overTimeBalance },
            { id: 4, name: $.strings.recalculateBalances.specialLeaveBalance },
        ];
        this.state = {
            loading: true,
            isDesktop: window.innerWidth > 1250,
            visibleDialog: false,
            firstExecution: false,
            pageInfo: this.setPageInfo(),
            sectionsList: [],
            employeesList: [],
            data: [],
            dataObject: {
                section: [],
                employees: [],
                date: new Date(),
                processType: this.processTypesList && this.processTypesList.length > 0 ? this.processTypesList[0] : undefined,
                // displayReportInFractions: false,
                // onlyWorkingStaff: true,
                additionalFiltersObj: undefined
            }
        }
    }
    componentDidMount = async () => {
        if (!Util.checkISHR()) {
            Util.goTo('/Access');
        }
        let _isDesktop = window.innerWidth > 1250

        let sectionsList = await this.getSections();
        let employeesList = await this.getEmployeesList();
        this.setState({ employeesList: employeesList, sectionsList: sectionsList, isDesktop: _isDesktop, loading: false })
    }

    handleUserInput = (e) => {
        const name = e.target.id;
        const value = e.target.value;
        this.setState({ dataObject: { ...this.state.dataObject, [name]: value } });
    }

    handleMultiSelect = (e) => {
        const name = e.target.id;
        const value = e.target.value;
        this.setState({ dataObject: { ...this.state.dataObject, [name]: value } });
    }

    render() {
        const footer = (
            <div style={{ textAlign: 'center' }}>
                <Button label={$.strings.cancel} icon="" className="p-button-danger" onClick={this.onHide}>
                    &nbsp;&nbsp;
                    <i className="pi pi-times" />
                </Button>
            </div>
        );

        const gridStyle = { minHeight: '40vh' }
        let siteMapItems = [
            { label: $.strings.links.reports.menu },
            { label: this.state.pageInfo.title }
        ];
        const siteMapHome = { icon: 'pi pi-home', url: "/" }
        return (
            <div style={{ direction: $.strings.dir }}>
                <ProgressSpinner loading={this.state.loading} />
                <Card>
                    <SiteMap model={siteMapItems} home={siteMapHome} />
                    <ButtonsBarLookupList onRefresh={e => this.onRefresh(false)} onExcelExport={this.excelExport} onPrint={this.print} />
                    <Messages innerRef={(el) => this.messages = el} />
                    <AdditionalFilters ref={e => this.dlgAdditionalFilters = e} onSuccess={this.onAdditionalFiltersSuccess} />
                </Card>
                <div ref="divMain" >
                    <Accordion activeIndex={0}>
                        <AccordionTab header={$.strings.filterCaption}>
                            <div className="p-grid">
                                <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                    <MultiSelect
                                        id="section"
                                        innerRef={e => this.drpSection = e}
                                        value={this.state.dataObject.section}
                                        options={this.state.sectionsList}
                                        caption={$.strings.recalculateBalances.section}
                                        onChange={(e) => this.handleUserInput(e)}
                                        optionLabel="Name"
                                        display="chip"
                                        maxSelectedLabels="2"
                                        filter={true}
                                    />
                                </div>
                                <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                    <MultiSelect
                                        id="employees"
                                        value={this.state.dataObject.employees}
                                        options={this.state.employeesList}
                                        caption={$.strings.recalculateBalances.employee}
                                        onChange={this.handleMultiSelect}
                                        optionLabel="name"
                                        display="chip"
                                        maxSelectedLabels="2"
                                        showSelectAll={false}
                                        filter
                                    />
                                </div>
                                <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                    <Calendar
                                        id="date"
                                        value={this.state.dataObject.date}
                                        caption={$.strings.recalculateBalances.date}
                                        onChange={this.handleUserInput}
                                        readOnlyInput={true}
                                        readOnly={true} 
                                    />
                                </div>
                                <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                    <Dropdown
                                        id="processType"
                                        value={this.state.dataObject.processType}
                                        options={this.processTypesList}
                                        caption={$.strings.specialLeavesBalancesProcess.processType}
                                        onChange={this.handleUserInput}
                                        optionLabel="name"
                                    />
                                </div>
                                <div className="p-col-6 p-xl-2 p-lg-4 p-md-4 p-sm-12" style={{ alignSelf: 'flex-end', marginBottom: '5px' }}>
                                    <Button label={$.strings.additionalFilters.title} className={this.state.dataObject.additionalFiltersObj ? 'p-button-warning' : ''}
                                        onClick={e => this.dlgAdditionalFilters.show(this.state.dataObject.additionalFiltersObj)} />
                                    <Button label="" icon="pi pi-filter-slash" visible={this.state.dataObject.additionalFiltersObj} tooltip={$.strings.additionalFilters.clearFilters}
                                        onClick={e => this.setState({ dataObject: { ...this.state.dataObject, additionalFiltersObj: undefined } })}
                                    />
                                </div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                                    <Button label={$.strings.firstExecution} icon="pi pi-check" onClick={this.onFirstExecution}
                                        disabled={!this.state.data || this.state.data.length <= 0} />
                                </div>
                                <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                                    <Button label={$.strings.saveData} icon="pi pi-save" className="p-button-success" onClick={this.onSaveData}
                                        disabled={!this.state.data || this.state.data.length <= 0 || !this.state.firstExecution} />
                                </div>
                            </div>
                        </AccordionTab>
                    </Accordion>
                    <Card>
                        <div className="p-grid">
                            <div className="p-col-12 p-lg-12 p-sm-12">
                                <DataGrid
                                    style={gridStyle}
                                    ref={e => this.gridData = e}
                                    isReport={true}
                                    theme="default-light"
                                    idProperty="RowNumber"
                                    exportFileName={this.state.pageInfo.title}
                                    scheme={this.getScheme()}
                                    dataSource={this.state.data}
                                />
                            </div>
                        </div>
                    </Card>
                </div >
            </div>
        );
    }
    onAdditionalFiltersSuccess = (obj) => {
        if (obj) {
            this.setState({ dataObject: { ...this.state.dataObject, additionalFiltersObj: obj } })
        }
    }

    getSections = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            empCode: localStorage.getItem("useridHR")
        }
        let res = await http.getJsonAxios(http.actions.Sections.urlGetSections, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
            // if (dataTemp) {
            //     dataTemp.splice(0, 1);
            // }
        }
        return dataTemp
    }
    getEmployeesList = async () => {
        let dataTemp = []
        let obj = {
            userId: localStorage.getItem('useridHR'),
            searchValue: !this.state.empCodeOrName || this.state.empCodeOrName.length <= 0 ? '' : this.state.empCodeOrName,
            isHr: Util.checkISHR(),
            getEmpStatus: this.state.getEmpStatus ? this.state.getEmpStatus : false,
            section: this.state.section && this.state.section.ID >= 0 ? this.state.section.ID : "-1",
            empStatus: this.state.empStatus && this.state.empStatus.id >= 0 ? this.state.empStatus.id : -1,
        }

        let res = await http.getJsonAxios(http.actions.Employee.urlGetEmployees, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.empObjList;

        }
        return dataTemp
    }

    onFirstExecution = () => {
        let dataTemp = this.state.data;
        if (dataTemp) {
            let data = dataTemp.filter(e => e.Selected === true);

            this.setState({ data: data, firstExecution: true });
        }
    }

    onSaveData = async () => {
        if (!this.state.dataObject.date) {
            Util.showErrorMsg(this.messages, $.strings.recalculateBalances.dateError)
            return;
        }
        if (!this.state.data || this.state.data.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.recalculateBalances.dataError)
            return;
        }
        this.setState({ loading: true });
        let success = false;
        let dataTemp = this.state.data;
        const params = {
            FromDate: this.state.dataObject.date,
            dt: this.state.data,
            UserId: localStorage.getItem("useridHR") + "",
            processType: this.state.dataObject.processType.id
        }

        let res = await http.postMultipartAxios(http.actions.Reports.urlPostSaveReCalculateBalances, params, this.state.pageInfo.pageId);
        if (res.status === 200) {
            if (res.data && res.data.success) {
                success = res.data.success;
                dataTemp = res.data.dt;
                if (success) {
                    Util.showSuccessMsg(this.messages);
                }
            }
            else {
                let msg = $.strings.operationFailed;
                if (res.data.message && res.data.message.length > 0) {
                    msg = res.data.message;
                    Util.showErrorMsg(this.messages, msg, false);
                }
            }
        }
        else {
            let msg = $.strings.operationFailed;
            if (res.data.message && res.data.message.length > 0) {
                msg = res.data.message;
                Util.showErrorMsg(this.messages, msg, false);
            }
        }
        this.setState({ data: dataTemp, loading: false })
    }

    onRefresh = async (fromLoad) => {
        if (!this.state.dataObject.date) {
            Util.showErrorMsg(this.messages, $.strings.recalculateBalances.dateError)
            return;
        }

        if (!fromLoad) {
            this.setState({ loading: true, firstExecution: false });
        }
        let data = []
        let generalFillter = {};

        if (this.state.dataObject.section) {
            let sectionsList = []
            for (let index = 0; index < this.state.dataObject.section.length; index++) {
                sectionsList.push(this.state.dataObject.section[index].Code)
            }
            generalFillter.SectionList = sectionsList;
        }
        if (this.state.dataObject.employees) {
            let empList = [];
            for (let index = 0; index < this.state.dataObject.employees.length; index++) {
                empList.push(this.state.dataObject.employees[index].code)
            }
            generalFillter.EmpList = empList;
        }
        Util.fillAditionalsFilters(this.state.dataObject.additionalFiltersObj, generalFillter);

        let obj = {
            fromDate: this.state.dataObject.date,
            fromCode: '',
            toCode: '',
            processType: this.state.dataObject.processType ? this.state.dataObject.processType.id : -1,
            GeneralFillter: generalFillter
        }
        let res = await http.postMultipartAxios(http.actions.Reports.urlPostReCalculateBalances, obj, null, null, 0);
        if (res && res.status === 200) {
            if (res.data && res.data.success)
                data = res.data.list;
            if (data && data.length > 0) {
                data.forEach(element => {
                    element.Selected = true;
                });
            }
        }
        if (!fromLoad) {
            this.setState({ data: data, loading: false }, () => this.printFilters = this.state.dataObject);
        }
        else {
            return data;
        }
    }

    excelExport = () => {
        this.gridData.exportCSV();
    }

    print = () => {

        if (!this.state.data || this.state.data.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }

        let obj = Print.getReportPrintObject(this.state.pageInfo.title, this.gridData, this.state.data);
        if (!obj || !obj.data || obj.data.columns.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }
        let listOfFilters = [];
        if (this.printFilters) {
            let dateFilter = "";

            if (this.printFilters.section && this.printFilters.section.length === 1) {
                let sectionFilter = "";
                sectionFilter += " " + $.strings.recalculateBalances.section + ": ";
                for (let index = 0; index < this.printFilters.section.length; index++) {
                    let name = this.printFilters.section[index].Name;
                    if (index > 0)
                        sectionFilter += ", ";
                    sectionFilter += " " + name;
                }
                if (sectionFilter !== "")
                    listOfFilters.push(sectionFilter);
            }

            if (this.printFilters.employees && this.printFilters.employees.length === 1) {
                let employeesFilter = "";
                employeesFilter += " " + $.strings.recalculateBalances.employee + ": ";
                for (let index = 0; index < this.printFilters.employees.length; index++) {
                    let name = this.printFilters.employees[index].name;
                    if (index > 0)
                        employeesFilter += ", ";
                    employeesFilter += " " + name;
                }
                if (employeesFilter !== "")
                    listOfFilters.push(employeesFilter);
            }

            // Date Filter
            if (this.printFilters.date) {
                dateFilter = $.strings.recalculateBalances.date + ": " + Util.getDateFormat(this.printFilters.date);
            }
            // if (this.printFilters.toDate) {
            //     if (dateFilter !== "")
            //         dateFilter += " - ";
            //     else
            //         dateFilter = $.strings.salariesPerDay.fromDate + ": ";
            //     dateFilter += Util.getDateFormat(this.printFilters.toDate);
            // }
            if (dateFilter !== "")
                listOfFilters.push(dateFilter)

            if (this.printFilters.processType) {
                listOfFilters.push($.strings.specialLeavesBalancesProcess.processType + ": " + this.printFilters.processType.name)
            }


        }
        obj.headers = Print.getPrintingHeaderStrings(listOfFilters, obj.headers)

        Print.doPrintReport(obj);
    };

    getScheme = () => {
        return {
            name: "recalculateBalancesScheme_Table",
            filter: false,
            showFooter: true,
            sortable: false,
            allowGrouping: false,
            responsiveColumnIndex: 2,
            columns: [

                { name: 'RowNumber', header: '##', width: 60, dataType: 'Number', aggregate: 'Cnt', columnWidth: '1' },
                { name: 'Code', header: $.strings.recalculateBalances.empCode, width: 120, columnWidth: '2' },
                { name: 'Name', header: $.strings.recalculateBalances.empName, width: "*", minWidth: 120, columnWidth: '*' },
                { name: 'Balance', header: $.strings.recalculateBalances.fileBalance, width: 150, dataType: 'Number', columnWidth: '2' },
                { name: 'CalcBalance', header: $.strings.recalculateBalances.calculatedBalance, width: 150, dataType: 'Number', columnWidth: '3' },
                { name: 'Difference', header: $.strings.recalculateBalances.difference, width: 150, dataType: 'Number', columnWidth: '2' },
                { name: 'Notes', header: $.strings.recalculateBalances.notes, width: 250, columnWidth: '*' },
                { name: 'FullTime', header: 'FullTime', visible: false, visibleInColumnChooser: false },
            ]
        }
    }

    setPageInfo = () => {
        let pageId
        let title = $.strings.recalculateBalances.title;

        return { pageId: pageId, title: title };
    };
}